import React from "react"
import { batch } from "@preact/signals-react"

import { AppAntSwitch } from "@components"
import { directSiteBrokerProvider, mainProvider, mainSite } from "@signals"


export default function AppCommonFiltersDirectSiteBrokerProviderToggleButton({ ...props }) {
	return <AppAntSwitch
		falseText="Main Direct Site"
		trueText="Main Provider"
		checked={directSiteBrokerProvider.value}
		onChange={newValue => batch(() => {
			directSiteBrokerProvider.value = newValue.target.checked
			mainSite.value = ''
			mainProvider.value = ''
		})}
		{...props}
	/>
}